import React from 'react';

interface LoaderProps {
  size?: number; // Size of the loader
  color?: string; // Spinner color
  backgroundColor?: string; // Background color
  fullScreen?: boolean; // Whether to cover the full screen
}

export const Loader: React.FC<LoaderProps> = ({
  size = 40,
  color = '#FF6F61',
  backgroundColor = '#F5F7F9',
  fullScreen = true,
}) => {
  return (
    <div
      className={`flex items-center justify-center ${
        fullScreen ? 'h-svh w-full' : ''
      }`}
      style={{ backgroundColor }}
    >
      <div
        className="border-4 border-gray-300 rounded-full animate-spin"
        style={{
          width: size,
          height: size,
          borderColor: 'gray',
          borderTopColor: color,
        }}
      ></div>
    </div>
  );
};
